const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.218,
    height: 143.376,
    viewBox: "0 0 171.259 170.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#347b98",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "1.18750358px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m.552 170.26-.554-89.13C.115 30.545 44.725-.156 85.827 0h85.43v85.053c-.494 47.823-38.168 85.563-85.43 85.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "none",
      strokeWidth: "1.18750358px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M19.436 29.319v83.55H34.13l.42-57.94c2.027-17.336 16.278-30.15 17.634-2.099v60.458h14.694l.42-55.759c4.034-30.681 17.998-13.027 17.634-3.02l.097 59.593c4.284 36.749 35.674 45.719 64.998 27.292 2.573-2.06 1.99-.606 4.465-5.637l-5.324-10.293c-62.484 35.31-64.075-61.575-12.176-42.825v14.695h14.695v-25.61c-16.812-5.127-33.348-12.785-52.06-.42l.419-28.13c-1.564-20.915-21.216-26.117-35.687-9.237-17.321-21.94-30.802-3.131-31.98-.123l-2.027-8.274h-7.558z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.30ca4699df20fc57f882383a20616b06.svg";
export { ForwardRef as ReactComponent };